import {useMutation, useQueryClient} from '@tanstack/react-query';
import {cancelReportJob} from 'src/services/reportService';
import {reportJobsKeys} from './queries';

export const useCancelReportJob = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => cancelReportJob(id),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: reportJobsKeys.all});
    },
  });
};
